import React, { FC } from 'react';
import './Achievement.css';
import { motion } from "framer-motion"

interface AchievementProps {
  icon: string;
  title: string;
  description: string;
  onClick: () => void;
}

export const Achievement: FC<AchievementProps> = ({ icon, title, description, onClick }) => {
  return (
    <motion.div 
      initial={{ x: -100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100 }}
      className="achievement" onClick={onClick}>
      <h5>
        <span style={{ display: "inline-flex", alignItems: "center", marginRight: "8px" }}>
          <img
            src={process.env.PUBLIC_URL + icon}
            alt=""
            width={24}
            height={24}
            style={{ display: 'inline', marginRight: '6px', verticalAlign: 'middle' }}
            aria-hidden="true"
          />
          {title}
        </span>
      </h5>
      <p>{description}</p>
    </motion.div>
  );
};